import loadable from "@loadable/component";

const Careers = loadable(() => import("./Careers.page"));

export default { component: Careers };
